import * as React from "react";

import "./Benefits.css";

interface BenefitsProps {}

// TODO: probably an image + background image on the text
const Benefits = (props: BenefitsProps) =>
  <section className="order-success-benefits success-green">
    <div className="order-success-benefits__title">
      Với tài khoản Express Design bạn có thể sử dụng các tiện ích:
    </div>
    <ul className="order-success-benefits__list">
      <li className="order-success-benefits__list-item">
        5GB dữ liệu lưu trữ các sản phẩm
      </li>
      <li className="order-success-benefits__list-item">
        Xem trạng thái tiến hành của sản phẩm
      </li>
      <li className="order-success-benefits__list-item">
        Phản hồi, comment sản phẩm không cần qua email
      </li>
      <li className="order-success-benefits__list-item">
        Chuyên viên tư vấn 24/7
      </li>
      <li className="order-success-benefits__list-item">
        Chia sẻ các sản phẩm thiết kế
      </li>
      <li className="order-success-benefits__list-item">
        Nhận các ưu đãi, mã giảm giá thiết kế
      </li>
    </ul>
  </section>;

export default Benefits;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/Benefits.tsx